import React, { Component } from "react";
import { Tab, Tabs } from 'react-bootstrap';
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import TestPaymentMethodBadge from "../../customer/TestPaymentMethodBadge";
import TestModeAlert from "../../payment-processing/components/TestModeAlert";
import CreditCardLabel from "../../payment/creditcard.component";
import { PAYMENT_METHOD } from "../../state/helpers/Payment";
import ActionButton from "../button/actionbutton.component";
import OnlinePayment from "./online-payment.component";

const messages = defineMessages({
    cards_on_file: {
        id: "invoice.receive_payment.cards_on_file_tab",
        defaultMessage: "Cards on file",
    },
    add_credit_card: {
        id: "invoice.receive_payment.credit_card_tab",
        defaultMessage: "Credit Card",
    }
})

class CreditCardSelector extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            onSubmit: this.props.onSubmit || function () { },
            handleSubmitExistingCard: this.props.handleSubmitExistingCard || function () { },
            selectedCard: {},
            key: 'cards-on-file',
            updateSize: this.props.updateSize || function () { },
            cardsOnFile: this.props.cardsOnFile,
            countryCode: this.props.countryCode,
            contactId: this.props.contactId,
            savedCardToken: '',
            creditCardError: '',
            savedCardPaymentFlow: '',
        }
    }

    isCreditCardExpired(creditCard) {
        let today = new Date()
        let creditCardExpirationDate = new Date(
            creditCard.attributes.card.attributes.expirationYear,
            (creditCard.attributes.card.attributes.expirationMonth - 1)
        )
        return creditCardExpirationDate.getTime() < today.getTime()
    }

    render() {
        return (<div className="form-group row mb-1 justify-content-end">
            <Tabs
                defaultActiveKey={"cards-on-file"}
                className="justify-content-end w-100"
                onSelect={() => {
                    setTimeout(this.state.updateSize, 500)
                }}
            >
                <Tab eventKey="cards-on-file" title={this.props.intl.formatMessage(messages["cards_on_file"])}>
                    <div className={'col-12 col-lg-6 mb-0 py-2 bg-light border ml-auto'}>
                        {this.state.cardsOnFile.map(c => {
                            return <div className={'w-100 d-flex flex-column py-2'} key={c.id}>
                                <TestModeAlert className="ignore-active"/>
                                <div className={'mr-2'}>
                                    <div className="custom-control custom-radio">
                                        <input
                                            type="radio"
                                            id={c.id}
                                            name="cardOnFile"
                                            disabled={this.isCreditCardExpired(c)}
                                            value={c.attributes.card.attributes.cardToken}
                                            checked={c.attributes.card.attributes.cardToken == this.state.savedCardToken}
                                            className="custom-control-input"
                                            onChange={e => {
                                                this.setState({
                                                    savedCardPaymentFlow: c.attributes.card.attributes.paymentFlowType,
                                                    savedCardToken: e.target.value,
                                                    selectedCard: c,
                                                })
                                            }}
                                        />
                                        <label
                                            className={this.isCreditCardExpired(c) ? "custom-control-label text-danger" : "custom-control-label"}
                                            htmlFor={c.id}
                                        >
                                            <CreditCardLabel value={c.attributes.card} />
                                            <span className={'mx-2'}>
                                                                    {c.attributes.card.attributes.expirationMonth + '/' + c.attributes.card.attributes.expirationYear}
                                                                </span>
                                            {c.attributes.card.attributes.cardHolderName}
                                            {c.attributes.isDefault && <span className="badge badge-primary ml-2 text-white-badge">
                                                                    <FormattedMessage
                                                                        id="cards_on_file.default_label"
                                                                        defaultMessage="Default"
                                                                    />
                                                                </span>}
                                                                {c.attributes.isTestPaymentMethod && <TestPaymentMethodBadge paymentMethodType={PAYMENT_METHOD.CREDIT_CARD}/>}
                                            {this.isCreditCardExpired(c) && <span className="badge badge-danger ml-2 text-white-badge">
                                                <FormattedMessage
                                                    id="cards_on_file_expired_label"
                                                    defaultMessage="Expired"
                                                />
                                            </span> }
                                        </label>
                                    </div>
                                </div>
                            </div>
                        })}
                        <div className={'w-100 text-right mt-3'}>
                            <div className={'col-12 col-lg-6 mb-0 py-2 ignore-active ml-auto'}>
                                <ActionButton
                                    disabled={this.state.savedCardToken == ''}
                                    className={'btn btn-primary'}
                                    isLoading={this.state.isLoading}
                                    onClick={() => this.state.handleSubmitExistingCard(this.state.selectedCard)}
                                >
                                    <FormattedMessage
                                        id="invoice.receive_payment.select_card_on_file_btn"
                                        defaultMessage="Select card on file"
                                    />
                                </ActionButton>
                                {this.state.creditCardError}
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="add-credit-card" title={this.props.intl.formatMessage(messages["add_credit_card"])} className={"w-100"}>
                    <div className={'col-12 col-lg-6 mb-0 py-2 bg-light border ignore-active ml-auto w-100'}>
                        <TestModeAlert />
                        <OnlinePayment
                            countryCode={this.state.countryCode}
                            onSubmit={this.state.onSubmit}
                            submitButton={<FormattedMessage
                                id="embed.ls_retail.new_invoice_modal.save_card_btn"
                                defaultMessage="Save card on file"
                            />}
                            submitDisabled={false}
                            forceSaveCard={true}
                            saveAndChargeLater={true}
                            contactId={this.state.contactId}
                        />
                        {this.state.creditCardError}
                    </div>
                </Tab>
            </Tabs>
        </div>
        )
    }
}

export default injectIntl(CreditCardSelector)


// WEBPACK FOOTER //
// ./src/common/credit-card/creditcardselector.component.jsx